import { render } from "./assetNoteButton.vue?vue&type=template&id=11d3153d&ts=true"
import script from "./assetNoteButton.vue?vue&type=script&lang=ts"
export * from "./assetNoteButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__